export const ssczhongsanqitateshuhaoma = {
	balls:[
	    [-1,-1,-1]
	],
    num:[
	    [0,1,2]
    ],
    views:[
	    ['豹子','顺子','对子']
    ],
    titles: [
        '特殊号码'
    ],
    getLottery:(num,balls)=>{
        let str = '';
        for(let i = 0,len_i = balls.length;i < len_i;i++){
		    for(let j = 0,len_j = balls[i].length;j < len_j;j++){          
			    if(balls[i][j] > 0){
                   str += str?'|':'';
                   str += num[i][j];
				}
		    }
    	}
	    return str;
    },
    getNum:(balls)=>{
        let num = 0;
        for(let i=0,len=balls.length;i<len;i++){
            for(let j=0,len_j = balls[i].length;j<len_j;j++){
                if(balls[i][j]>-1){
                    num += 1;
                }
            }
        }
        return num;
    },
    getView: (views,balls)=>{
        let str = ''; 
        for(let i = 0,len_i = balls.length;i < len_i;i++){
		    for(let j = 0,len_j = balls[i].length;j < len_j;j++){
			    if(balls[i][j] > 0){
                    str += str?'|':'';
                    str += views[i][j];
				}
		    }
    	}
	    return str;
    }
}
